import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import GroupIcon from "@mui/icons-material/Group";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  card: {
    borderRadius: 4,
    padding: "1.25rem 1.5rem",
    height: "100%",
    color: themeColorsDesingSystem.text.primary,
  },
  cardTotal: {
    backgroundColor: "#D9E6F2",
  },
  cardActive: {
    backgroundColor: "#DCEEDF",
  },
  cardInactive: {
    backgroundColor: "#F8E4DE",
  },
  title: {
    fontSize: "0.875rem",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  value: {
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: 1.1,
  },
  iconWrapper: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255,255,255,0.65)",
  },
});

function UserSummaryCard({ title, value, icon, cardClass }) {
  const classes = useStyles();

  return (
    <Box className={`${classes.card} ${cardClass}`}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.value}>{value ?? "-"}</Typography>
        </Box>
        <Box className={classes.iconWrapper}>{icon}</Box>
      </Box>
    </Box>
  );
}

export default function UserSummaryCards({ stats, loading }) {
  const classes = useStyles();
  const isMobile = IsMobile();
  const itemSize = isMobile ? 12 : 4;

  const displayValue = (value) => (loading ? "-" : value ?? 0);

  return (
    <Grid container spacing={2} style={{ marginBottom: "1.5rem" }}>
      <Grid item xs={itemSize}>
        <UserSummaryCard
          title="Total de Usuário cadastrados"
          value={displayValue(stats?.TotalUsuarios)}
          icon={<GroupIcon />}
          cardClass={classes.cardTotal}
        />
      </Grid>
      <Grid item xs={itemSize}>
        <UserSummaryCard
          title="Usuários Ativos"
          value={displayValue(stats?.UsuariosAtivos)}
          icon={<PersonOutlineIcon />}
          cardClass={classes.cardActive}
        />
      </Grid>
      <Grid item xs={itemSize}>
        <UserSummaryCard
          title="Usuários Inativos"
          value={displayValue(stats?.UsuariosInativos)}
          icon={<PersonOffIcon />}
          cardClass={classes.cardInactive}
        />
      </Grid>
    </Grid>
  );
}
